import React, { useState } from "react";
import { Navbar, Nav } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import logo from "./logo60.png";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/conception", label: "Conception" },
  { to: "/contact", label: "Contact" },
];

const Navbar2 = () => {
  const [expanded, setExpanded] = useState(false);

  const handleNavLinkClick = () => {
    setExpanded(false); // Ferme le menu mobile au clic sur un lien
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      className="p-3"
      sticky="top"
      expanded={expanded}
      style={{ top: "-1px" }}
    >
      <Navbar.Brand as={Link} to="/" onClick={handleNavLinkClick}>
        <img
          src={logo}
          alt="Makni Renov' - rénovation à Paris 12"
          height="40"
          style={{ padding: 0, margin: 0 }}
          className="d-inline-block align-top"
        />{" "}
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="navbarNavDropdown"
        onClick={() => setExpanded(!expanded)}
      />
      <Navbar.Collapse id="navbarNavDropdown">
        <Nav className="ms-auto">
          {links.map((item) => (
            <Nav.Link
              key={item.to}
              as={NavLink}
              to={item.to}
              end
              className="mx-2"
              onClick={handleNavLinkClick}
            >
              {item.label}
            </Nav.Link>
          ))}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navbar2;
